/* eslint-disable @typescript-eslint/no-explicit-any */
import asyncStorage from '@react-native-async-storage/async-storage';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import React from 'react';
import {Platform, ScrollView, Text, View} from 'react-native';
import {ValidationDevis} from '../../../../../common/utils/validationAssuranceVoyage';
import {defaultValues} from '../../../../../data/constants/Assurance/AssuranceVoyage/devis';
import {voyage} from '../../../../../data/constants/voyage';
import {SubmitDevisVoyage} from '../../../../../data/types/interface/Assurance/AssuranceVoyage/devis';
import {useFormDevis} from '../../../../../hooks/AssuranceVoyage/useFormDevis';
import {IPostDevis} from '../../../../../services/applicatif/voyages';
import {AssuranceVoyageContainer} from '../../../../components/Assurance/Voyage/Container';
import {buttonsStyles} from '../../../../components/Button/boutonStyle';
import Button from '../../../../components/Button/PrimaryButton';
import {
  itemI,
  MultiDatePicker,
} from '../../../../components/Inputs/DatePickerModal/MultiDatePicker';
import {formsStyles} from '../../../../components/Inputs/formStyles';
import {InputDatePicker} from '../../../../components/Inputs/InputDatePicker';
import {InputField} from '../../../../components/Inputs/InputField';
import Select from '../../../../components/Inputs/Select';
import Label from '../../../../components/Label';
import ConfirmationModal from '../../../../components/Modal/ConfirmationModal';
import {styles} from './styles';

interface FormDevisMobileProps {
  datas: SubmitDevisVoyage;
  setDatas: (values: SubmitDevisVoyage) => void;
  listCategories: Array<any>;
  onSave: (values: IPostDevis & SubmitDevisVoyage) => void;
  onCancel: () => void;
}
export default function FormDevisMobile({
  datas,
  setDatas,
  listCategories,
  onSave,
  onCancel,
}: FormDevisMobileProps) {
  const {
    handleChange,
    handleSubmit,
    handleCancel,
    values,
    errors,
    showErrors,
    modalData,
    categories,
    destinations,
    ageLimit,
    ageList,
  } = useFormDevis(
    datas,
    setDatas,
    ValidationDevis,
    onSave,
    onCancel,
    listCategories,
  );
  asyncStorage.setItem('ageLimit', ageLimit.toString());

  return (
    <AssuranceVoyageContainer
      style={{
        flex: 1,
        backgroundColor: 'white',
        paddingHorizontal: Platform.OS === 'web' ? 40 : 0,
      }}>
      <View style={{paddingHorizontal: 20, paddingBottom: 20}}>
        <Label title={'DEVIS POUR UNE ASSURANCE VOYAGE'} type="mainTitle" />
        <Label
          title="(La souscription à l'assurance voyage requiert l'obtention d'un devis au préalable.)"
          type="fourthTitle"
        />
      </View>
      <ScrollView style={{flex: 1, paddingHorizontal: 20}}>
        <View
          style={
            Platform.OS === 'web'
              ? {flexDirection: 'row', justifyContent: 'space-between'}
              : undefined
          }>
          <Select
            style={{flex: 0.45}}
            data={categories}
            label="Catégorie"
            defaultValue={defaultValues.category}
            required={true}
            name="categoryCode"
            onChange={(name: string, data: any) => {
              handleChange(name, data, true);
            }}
            value={values.categoryCode}
            error={errors.categoryCode}
            showError={showErrors.categoryCode}
          />
          <Select
            style={{flex: 0.45}}
            data={destinations}
            label="Destination"
            defaultValue={defaultValues.destination}
            required={true}
            name="destinationCode"
            onChange={(name: string, data: any) => {
              handleChange(name, data, true);
            }}
            value={values.destinationCode}
            error={errors.destinationCode}
            showError={showErrors.destinationCode}
          />
        </View>
        <View style={styles.dateTimePickerWrapper}>
          <MultiDatePicker
            label={'Liste de Date de naissances'}
            required
            listDate={values.listNaissance}
            onChange={(list: itemI[]) =>
              handleChange('listNaissance', list, true)
            }
            min={new Date(1940, 2, 20)}
            max={new Date()}
            error={errors.listNaissance}
            showError={showErrors.listNaissance}
          />
        </View>
        <InputDatePicker
          label={'Date de couverture (début)'}
          required
          value={values.dateDebut}
          name="dateDebut"
          onChange={handleChange}
          error={errors.dateDebut}
          showError={showErrors.dateDebut}
          dateMin={dayjs().add(1, 'day').toDate()}
          noInit
        />
        <InputDatePicker
          label={`Date de couverture (fin) total de ${
            dayjs(values.dateFin).diff(dayjs(values.dateDebut), 'days') || 0
          } jours`}
          required
          value={values.dateFin}
          name="dateFin"
          onChange={handleChange}
          error={errors.dateFin}
          showError={showErrors.dateFin}
          dateMin={
            values.dateDebut
              ? dayjs(values.dateDebut).add(1, 'day').toDate()
              : dayjs().add(2, 'day').toDate()
          }
          dateMax={
            values?.categoryCode?.includes(voyage.keyPelerinage)
              ? dayjs(values.dateDebut).add(29, 'day').toDate()
              : undefined
          }
          isEditable={!!values.dateDebut}
          noInit
        />
        <Text style={[formsStyles.labelStyle]}>
          Nombre d'enfant(s){' '}
          <Text style={{color: 'rgba(15, 87, 158, 1)'}}>(moins de 19 ans)</Text>
        </Text>
        <InputField
          type="numeric"
          required
          name="enfant"
          value={String(ageList.childrens) || ''}
          isEditable={false}
        />
        <InputField
          label={`Nombre d'adulte(s)`}
          type="numeric"
          required
          name="adult"
          value={String(ageList.adults) || ''}
          isEditable={false}
        />
        <Text style={[formsStyles.labelStyle]}>
          Nombre de senior(s){' '}
          <Text style={{color: 'rgba(15, 87, 158, 1)'}}>
            (à partir de 66 ans)
          </Text>
        </Text>
        <InputField
          type="numeric"
          required
          name="senior"
          value={String(ageList.seniors) || ''}
          isEditable={false}
        />
        <InputField
          label={'Motif de voyage'}
          type="textArea"
          name="motif"
          value={values.motif}
          onChange={handleChange}
          error={errors.motif}
          showError={showErrors.motif}
          placeholder="Votre commentaire ..."
        />
        <View style={{height: 120}} />
      </ScrollView>
      {modalData.status && (
        <ConfirmationModal
          title={modalData.title}
          content={modalData.content}
          btn1={modalData.btn1}
          btn2={modalData.btn2}
          handleBtn1={modalData.handleBtn1}
          handleBtn2={modalData.handleBtn1}
        />
      )}
      <View
        style={[
          buttonsStyles.displayCenter,
          {
            position: 'absolute',
            width: '100%',
            bottom: 0,
            left: 0,
            paddingTop: 5,
            paddingHorizontal: 20,
            backgroundColor: 'white',
          },
        ]}>
        <View style={buttonsStyles.displayHorizontal}>
          <Button
            onPress={() => handleCancel()}
            styleBtnTxt={buttonsStyles.btnAnnuler}
            styleBtnOuter={buttonsStyles.btnAnnulerOuterSimu}
            title="Annuler"
            type="annuler"
          />
          <Button
            onPress={() => handleSubmit()}
            styleBtnTxt={buttonsStyles.btnValider}
            styleBtnOuter={buttonsStyles.btnValiderOuterSimu}
            title="Générer devis"
            type="valider"
          />
        </View>
      </View>
    </AssuranceVoyageContainer>
  );
}
